<template>
    <div>
        <div class="card">
            <div class="bg-blue-light px-1 rounded pb-2">
                <TitleButton
                        class="mt-1"
                        btnTitle="Go Back"
                        title="Create Contra"
                        @onClickCloseButton="goToList"
                >
                  <template #extra-btn>
                    <div class="template-selection">
                      <label class="form-label">Template Contra Voucher</label>
                      <AsyncSelect
                          placeholder="Select Template"
                          v-model="template"
                          class="w-100"
                          :additional-query="{ template_type: 'contra'}"
                          :api-service="fetchTemplates"
                      />
                    </div>
                  </template>
                </TitleButton>
                <div class="row mt-1">
                    <div class="cols-12 col-sm-6 col-lg-4 col-xxl-3">
                        <label for="colFormLabel" class="col-form-label">Date</label>
                        <input
                                class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                                tabindex="1"
                                type="date"
                                placeholder=""
                                v-model="contra.date"
                        >
                    </div>

                    <div class="cols-12 col-sm-6 col-lg-4 col-xxl-3">
                        <label for="colFormLabel" class="col-xl-3 col-form-label">Amount</label>
                        <input
                                v-model="amount"
                                @input="onInputAmount"
                                type="number"
                                class="form-control text-end"
                                placeholder="Amount"
                        >
                    </div>
                    <div class="cols-12 col-sm-6 col-lg-4 col-xxl-3">
                        <label for="colFormLabel" class="col-form-label">Party</label>
                        <AsyncSelect
                            placeholder="Select Party"
                            v-model="contactProfile"
                            :api-service="fetchContactProfiles"
                            :format-label="formatPatientLabel"
                        />
                    </div>
                    <div class="cols-12 col-sm-6 col-lg-4 col-xxl-3 d-flex align-items-end gap-2">
                        <div class="flex-grow-1">
                            <label class="col-form-label">Payment Ref</label>
                          <div class="d-flex">
                            <input
                                    v-model="contra.payment_ref"
                                    type="text"
                                    class="form-control"
                                    placeholder="Cheque No"
                                    :disabled="!!chequeRegisterId"
                            >
                            <button class="btn btn-primary btn-sm ms-1" @click="isChequeModalOpen = true"><i class="fa fa-plus"></i></button>
                          </div>
                        </div>
                    </div>
                    <div class="cols-12 col-sm-6 col-lg-4 col-xxl-3">
                        <label for="colFormLabel" class="col-form-label">Payment Ref date</label>
                        <input
                                class="form-control invoice-edit-input date-picker flatpickr-input flatpickr-mobile"
                                tabindex="1"
                                type="date"
                                placeholder=""
                                v-model="contra.payment_ref_date"
                        >
                    </div>
                </div>
            </div>
            <div class="card p-2">
                <AddFormElement
                    class="mb-2"
                    :accountHeads="accountHeads"
                    :projects="projects"
                    :costCentres="costCentres"
                    :contactProfiles="contactProfiles"
                    :businesses="businesses"
                    v-for="(item, index) in contra.ledgers"
                    :key="index"
                    :index="index"
                    :item="item"
                />
                <div class="row mt-3">
                    <div class="col-12">
                        <div class="mb-2">
                            <label for="attachment" class="form-label fw-bold">Attachment</label>
                            <BlobFileViewer :attachments="contra.attachments" />
                            <FileUpload
                                    :is-drag-active="true"
                                    button-text="Upload Documents"
                                    v-model="contra.attachments"
                            >
                            </FileUpload>
                        </div>
                    </div>
                </div>
                <div class="row mt-3">
                    <div class="col-12">
                        <div class="mb-2">
                            <label for="note" class="form-label fw-bold">Memo</label>
                            <textarea v-model="contra.note" placeholder="Memo" class="form-control" rows="2" id="note"></textarea>
                        </div>
                    </div>
                </div>

                <div class="mt-2 text-center">
                    <hr class="mb-1">
                    <button
                            :disabled="loading"
                            @click="saveContra(true)"
                            class="btn btn-primary me-1"
                    >
                        <div v-if="loading" class="spinner-border spinner-border-sm text-light" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        Save
                    </button>
                    <button
                            :disabled="saveNewLoader"
                            @click="saveContra(false)"
                            class="btn btn-primary me-1"
                    >
                        <div v-if="saveNewLoader" class="spinner-border spinner-border-sm text-light" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        Save & New
                    </button>
                    <button
                            :disabled="saveNewLoader"
                            @click="saveContra(true, true)"
                            class="btn btn-primary me-1"
                    >
                        <div v-if="saveNewLoader" class="spinner-border spinner-border-sm text-light" role="status">
                            <span class="visually-hidden">Loading...</span>
                        </div>
                        Save & Print
                    </button>
                    <button
                            @click="goToList"
                            class="btn btn-outline-secondary cancel-btn"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        <SelectChequeModal
            v-if="isChequeModalOpen"
            @selected="onChequeSelected"
            @close="isChequeModalOpen = false"
        />
        </div>
    </div>
</template>

<script setup>
import handleContra from '@/services/modules/contra'
import handleContact from '@/services/modules/contact'
import handleCBusinesses from '@/services/modules/businesses'
import {computed, inject, onMounted, ref, watch} from 'vue'
import TitleButton from '@/components/atom/TitleButton'
import AddFormElement from '@/components/molecule/ngo/contra/AddFormElement'
import {useRoute, useRouter} from "vue-router";
import handleProjects from "@/services/modules/procurement/project";
import handleCostCentres from "@/services/modules/ngo/costCentre";
import FileUpload from "@/components/atom/FileUpload";
import BlobFileViewer from "@/components/atom/BlobFileViewer";
import figureFormatter from "@/services/utils/figureFormatter";
import pdfPrinterHelper from '@/services/utils/pdfPrinterHelper';
import handleTemplate from '@/services/modules/all-modules/template';
import AsyncSelect from "@/components/molecule/input-field/AsyncSelect.vue";
import SelectChequeModal from '@/views/page/company/ngo/voucher/payment/SelectChequeModal.vue';
import {useAsyncDropdownHelper} from '@/services/utils/asyncDropdownHelper';

const $route = useRoute();
const $router = useRouter()
const showError =  inject('showError');
const showSuccess =  inject('showSuccess');
const {fetchAccountHeads, createContra, loading, fetchSingleContra} = handleContra()
const {fetchContactProfiles} = handleContact()
const {fetchBusinessList} = handleCBusinesses()
const {fetchProjects} = handleProjects()
const {fetchCostCentreList} = handleCostCentres()
const {decimalFormat} = figureFormatter();
const {generatePdf} = pdfPrinterHelper();
const { fetchTemplates } = handleTemplate();
const { formatPatientLabel } = useAsyncDropdownHelper();

const amount = ref(null);
const accountHeads = ref([]);
const contactProfiles = ref([]);
const businesses = ref([]);
const projects = ref([]);
const costCentres = ref([]);
const saveNewLoader = ref(false);
const isChequeModalOpen = ref(false);
const chequeRegisterId = ref(null);
const template = ref(null);
const contactProfile = ref(null);
const contra =  ref({
    company_id:'',
    date: '',
    payment_ref: '',
    payment_ref_date: '',
    note: '',
    mop_references: 'mop',
    voucher_type: 'contra_voucher',
    attachments: [],
    ledgers: [
        {
            account_head_id: null,
            business_id: null,
            contact_profile_id: null,
            debit: null,
            credit: '',
            note: '',
            tax_rate: null,
            taxable_amount: null,

        },
        {
            account_head_id: null,
            business_id: null,
            contact_profile_id: null,
            debit: '',
            credit: null,
            note: '',
            tax_rate: null,
            taxable_amount: null,
        }
    ]
})
const contraRes = ref({});

//computed
const isLoading = computed(() => loading.value || saveNewLoader.value);
const start = computed(() => $route.query.start);
const end = computed(() => $route.query.end);
const general = computed(() => contra.value.ledgers);
const totalDebit = computed(() => {
    let total = 0;
    general.value.map(i => {
        if(i.debit) total += i.debit
    })
    return total
});

const onChequeSelected = ({ cheque, accountHeadId }) => {
    contra.value.payment_ref = `${cheque.cheque_number}`
    chequeRegisterId.value = cheque.id
}

//methods
const onInputAmount = ()  => {
    contra.value.ledgers[0].credit = amount.value
    contra.value.ledgers[1].debit = amount.value
}

watch(template, (newValue) => {
  if(newValue) {
    getSingleLedgerData();
  }
});

const getSingleLedgerData = async () => {

  const id = template.value && template.value.templateable_id;

  if(!id) return;

  fetchSingleContra(id).then( async res => {
    if (!res.status) {
      showError(res.message)
    }
    let data = res.data;
    delete data.voucher_no;
    contra.value = data
    contra.value.general_ledgers = data.ledgers;
    await setData()
  }).catch( err => {
    if(!err.response) {
      showError('Something is wrong. Check your connectivity!!')
    }
    if(err.response) {
      showError(err.response.message)
    }
  })
}

const setData = () => {
  contra.value.ledgers.sort((a, b) => {
    if(a.credit == null) return 1
    if(b.debit == null) return -1
  })
  amount.value = contra.value.ledgers.find(i => i.credit !=null).credit
}

const goToPrint = (id) => {
    const companyQuery = `?company_id=${$route.params.companyId}`;
    fetchSingleContra(id, companyQuery).then((res) => {
        contraRes.value = res.data
    }).then(() => {
        generatePdf($route.params.companyId, contraRes.value, 'contra')
    }).catch((e) => {
    console.log('Something went wrong')
  })
}

const goToList = () => {
    let params = {
        companyId: $route.params.companyId,
        moduleId: $route.params.moduleId,
        menuId: $route.params.menuId,
        pageId: $route.params.pageId
    }
    let query = {
        start: start.value,
        end: end.value
    }
    $router.push({
        name: 'np-contra-voucher-list',
        params: params,
        query: query
    })
}

const setVoucherNumberAndDate = (withoutDate = false) => {
    new Promise(async (resolve, reject) => {
        try {
            if (!withoutDate) {
                contra.value.date = new Date().toISOString().split('T')[0]
            }
            resolve();
        } catch (err) {
            reject(err);
        }
    })
}

const resetForm = async () => {
    amount.value = null;
    chequeRegisterId.value = null;
    contactProfile.value = null;
    contra.value = {
        company_id: '',
        date: '',
        payment_ref: '',
        payment_ref_date: '',
        note: '',
        mop_references: 'mop',
        voucher_type: 'contra_voucher',
        ledgers: [
            {
                account_head_id: null,
                business_id: null,
                project_id: null,
                donor_id: null,
                cost_centre_id: null,
                debit: '',
                credit: null,
                note: '',
                tax_rate: null,
                taxable_amount: null
            },
            {
                account_head_id: null,
                business_id: null,
                project_id: null,
                donor_id: null,
                cost_centre_id: null,
                debit: null,
                credit: '',
                note: '',
                tax_rate: null,
                taxable_amount: null
            }
        ]
    }
    await setVoucherNumberAndDate()
}

const getFormData = () => {
    contra.value.contact_profile_id = contactProfile.value && contactProfile.value.id ? contactProfile.value.id : ''
    if(!contra.value.business_id) contra.value.business_id = ''
    let formData = new FormData();
    Object.keys(contra.value).forEach(i => {
        if(i !== 'ledgers'|| i !== 'attachments') {
            formData.append(i, contra.value[i])
        }
    })
    let ledger = Object.assign([], general.value)
    ledger[0].debit = null;
    ledger[0].mop_account_head_id = ledger[1].account_head_id;
    ledger[1].credit = null;
    ledger[1].mop_account_head_id = ledger[0].account_head_id;
    formData.append('general_ledgers', JSON.stringify(ledger))

    if (chequeRegisterId.value) {
        formData.append('cheque_register_id', chequeRegisterId.value)
        formData.append('slug', 'is_cheque_register')
    }

    if(contra.value.attachments) {
        for(let i=0; i<contra.value.attachments.length; i++) {
            let key = `attachments[${i}]`;
            let value = contra.value.attachments[i];
            formData.append(key, value);
        }
    }
    return formData;
}

const saveContra = async (redirect = false, print = false) => {
    //createContra
    contra.value.company_id = $route.params.companyId;
    let data = getFormData();
    if (redirect) {
        loading.value = true
    } else {
        saveNewLoader.value = true
    }
    try {
        let res = await createContra(data)
        if (!res.status) {
            showError(res.message)
        }
        if (res.status) {
            showSuccess(res.message)
            resetForm()
            if (redirect && print) goToPrint(res.data.id)
        }
        if(redirect){
            $router.push({
              name: 'np-contra-voucher-list',
              params: {
                companyId: $route.params.companyId,
                moduleId: $route.params.moduleId,
                menuId: $route.params.menuId,
                pageId: $route.params.pageId,
              },
              query: {
                start: start.value,
                end: end.value
              }
            })                         
        }
    } catch (err) {
        if(!err.response) {
            showError('Something is wrong. Check your connectivity!!')
            return ;
        }

        if(err.response && err.response.status !== 406) {
            showError(err.response?.data.message)
        }
    } finally {
        loading.value = false
        saveNewLoader.value = false
    }
}

onMounted( () => {
    loading.value = true
    let companyId = $route.params.companyId;
    let contactId = '';
    let q = '';
    let companyQuery = '?company_id=' + companyId;
    let projectQuery = companyQuery + '&with_donors=1&status=active';
    contra.value.date = new Date().toISOString().split('T')[0];
    contra.value.company_id = companyId;
    try {
        Promise.all([
            fetchAccountHeads(companyId)
                .then(res => {
                    if (res.data) {
                        accountHeads.value = res.data
                    }
                }),
            fetchContactProfiles(companyQuery)
                .then(res => {
                    if (res.data) {
                        contactProfiles.value = res.data;
                    }
                }),
            fetchProjects(projectQuery)
                .then(res => {
                    if (res.data) {
                        projects.value = res.data;
                    }
                }),
            fetchCostCentreList(companyQuery).then(res => {
                if (res.data) {
                    costCentres.value = res.data
                }
            }),
            fetchBusinessList(companyQuery).then(res => {
              if(res.data) {
                businesses.value = res.data;
              }
            }),
            setVoucherNumberAndDate()
        ])
    } catch (e) {
        showError('Something went wrong please try again')
    } finally {
        loading.value = false
    }
});
</script>

<style scoped>
    .cancel-btn{
        background-color: #F0F2F5; color: #7D7D7D;
    }
    .cancel-btn:hover{
        background-color: #e9edf5;
    }
    hr{
        margin: 0 -3%;
        width: 106%;
    }
    .template-selection {
      width: 400px;
    }
    @media screen and (min-width: 1200px) {
    .btn-close {
        /* margin-left: 200px; */
        /* font-size: 32px; */
        /* margin-top: 5px; */
        width: 30px;
        height: 30px;
        background-color: #E4E6EB;
        border-radius: 50%;
        /* margin-right: 30px; */
    }
    .btn-close:hover {
        width: 30px;
        height: 30px;
        background-color: #D8DADF;
        border-radius: 50%;
    }
    }
    @media screen and (max-width: 720px) {
    .btn-close {
        width: 25px;
        height: 25px;
        background-color: #E4E6EB;
        border-radius: 50%;
        margin-top: -5px;
        margin-right: -5px;
    }
    }
</style>
